// extracted by mini-css-extract-plugin
export const homeVideo = "HomeVideo-module--home-video--ggw26";
export const homeVideo__mp4Wrapper = "HomeVideo-module--home-video__mp4-wrapper--17ulD";
export const homeVideo__mp4 = "HomeVideo-module--home-video__mp4--3_glq";
export const homeVideo__overlay = "HomeVideo-module--home-video__overlay--1k_eI";
export const overlayHidden = "HomeVideo-module--overlay-hidden--axA01";
export const homeVideo__button = "HomeVideo-module--home-video__button--2DKBV";
export const homeVideo__buttonPlay = "HomeVideo-module--home-video__button--play--2NDvy";
export const homeVideo__buttonFullscreen = "HomeVideo-module--home-video__button--fullscreen--hoyuq";
export const homeVideo__play = "HomeVideo-module--home-video__play--V68Vm";